import { types } from '../../types/types';
const intitalState = {
    rewards: [],
};

const rewardReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.SETTINGS.REWARDS.REWARD_TAB:
            return {
                ...state,
                rewards: action.payload,
            };

        default:
            return { ...state };
    }
};

export default rewardReducer;
